import { combineReducers } from 'redux'
import orders from './orders';
import user from './user';
import notification from './notification';
import globalVariable from './globalVariable';
import redeemOffer from './redeemOffer';
import chat from './chat';
export default combineReducers({
    orders,
    user,
    notification,
    globalVariable,
    redeemOffer,
    chat,
});
